import { medicalMessagesEN } from './lib/intl/en-US';
import { medicalMessagesES } from './lib/intl/es';

export const programId = '5f1a0fca3096441b6bf462aa';

export const defaultOptions = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com',
    },

    logLevel: 'error',
    useFingerprinting: true,
    messagesWithLocale: {
        'en-US': medicalMessagesEN,
        es: medicalMessagesES,
    },
};
